const cancel = 'Peruuta'
const save = 'Tallenna'

export default {

  global: {
    generalError: 'Voi pahus! Pyyntöä ei voitu käsitellä. Lataa sivu uudelleen.',
    signature: 'Ystävällisin terveisin',
  },

  component: {
    actionBar: {
      actions: 'Toiminnot',
      hideActions: 'Piilota toiminnot',
    },

    addButton: {
      add: 'Lisää',
    },

    attachments: {
      add: 'Lisää ansioluettelo tai muita liitteitä',
      placeholderWithDescription: 'Lisää pyydetyt liitteet',
      remove: 'Poista',
      allowedFileTypes: 'Sallitut tiedostotyypit',
      errors: {
        size: 'Tiedosto on liian suuri, maksimikoko tiedostolle on 5 Mt.',
        empty: 'Tiedosto on tyhjä',
        invalidType: fileType => `Valitettavasti ${fileType}-tiedostot eivät ole sallittuja turvallisuussyistä.`,
        typeNotWhitelisted: 'Valitettavasti tiedostotyyppi ei ole sallittu.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Tietosuojaselosteeseemme',
      termsLinkText: 'Käyttöehdot',
      privacyPolicyText: 'Arvostamme yksityisyyttäsi. Tutustuthan ',
      termsText1: 'Lue ja hyväksy ',
      termsText2: 'ennen kuin annat meille henkilökohtaisia tietojasi.',
      privacyLink: 'https://new.recright.com/fi/tietosuojaseloste',
      termsLink: 'https://new.recright.com/fi/recright-kayttoehdot-hakija',
      privacyInfo: mail => `Jos et halua että tietojasi käsitellään, voit lähettää poistopyynnön osoitteeseen ${mail}.`,
      customSupportPrivacyInfo: link => `Jos et halua että tietojasi käsitellään, voit lähettää poistopyynnön ottamalla yhteyttä ${link}.`,
    },

    buttons: {
      close: 'Sulje',
    },

    competencies: {
      addCompetency: 'Lisää uusi ominaisuus',
      edit: 'Muokkaa ominaisuuksia',
      done: 'Valmis',
      defaultsDescription: 'Jos et ole varma mitä ominaisuuksia käyttää, olemme määrittäneet muutaman oletusominaisuuden, joilla pääsee alkuun.',
      getDefaults: 'Hae oletusominaisuudet',
    },

    competency: {
      warning: 'Poista ominaisuus ja kaikki sille annetut arviot?',
    },

    confirmDelete: {
      delete: 'Poista',
      cancel: 'Peruuta',
      confirm: 'Vahvista',
    },

    confirm: {
      cancel: 'Poista otos',
      confirm: 'Yritä uudestaan',
    },

    confirmButton: {
      wait: count => `Odota ${count}`,
      confirm: 'Vahvista',
    },

    controlStatus: {
      text: {
        empty: 'Täytä',
        valid: () => 'Valmis',
      },
      textarea: {
        empty: 'Täytä',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Aseta',
        valid: () => 'Valmis',
      },
      file: {
        empty: 'Valitse',
        valid: () => 'Vaihda',
      },
      list: {
        empty: 'Lisää',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Hae',
        valid: () => 'Valmis',
      },
    },

    emailAddresses: {
      remove: 'Poista',
      importCsv: 'Import CSV',
      invalidEmails: 'Joukossa oli virheellisiä sähköpostiosoitteita.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'Csv:n riveillä voi olla joko email tai email,puhelin. Jokainen rivi esittää yhtä vastaanottajaa. Puhelinnumeroiden on oltava kansainvälisessä muodossa (E.164) esim. <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Vastaanotimme automaattisen vastausviestin. Varmista, että vastaanottaja sai viestin.',
      },
      Permanent: {
        General: 'Viestin lähetys epäonnistui. Vastaanottajan sähköpostipalveluntarjoaja hylkäsi viestin.',
        NoEmail: 'Sähköpostiosoitetta ei ole olemassa.',
        Suppressed: 'Sähköpostia ei toimitettu useiden epäonnistuneiden lähetysyritysten takia.',
      },
      Transient: {
        General: 'Vastaanotimme automaattisen vastausviestin. Varmista, että vastaanottaja sai viestin.',
        MailboxFull: 'Vastaanottajan sähköpostilaatikko on täynnä.',
        MessageTooLarge: 'Viestin sisältö on liian iso.',
        ContentRejected: 'Vastaanottajan sähköpostipalvelu ei hyväksynyt viestin sisältöä.',
        AttachmentRejected: 'Vastaanottajan sähköpostipalvelu ei hyväksynyt viestin liitteitä.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Pääsy kielletty',
      content: 'Tarkista, että olet kirjautunut oikealle tilille ja että sinut on kutsuttu käsittelemään tätä positiota. Varmista myös että käytät Recrightia vain yhdessä selainikkunassa kerrallaan.',
      link: 'Etusivulle',
    },

    error404: {
      heading: 'Sivua ei löydy',
      content: 'Etsimme huolella, mutta valitsemassasi osoitteessa ei ole mitään. Ehkä seurasit vanhentunutta linkkiä tai kirjoitit vahingossa väärin.',
      link: 'Etusivulle',
    },

    error410: {
      heading: 'Suljettu',
      content: 'Työpaikkaa ei voida näyttää, koska sen hakuaika ei ole voimassa tai se on poistettu.',
      link: 'Etusivulle',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    cookieConsentModal: {
      title: 'Nettisivumme käyttää evästeitä',
      body: 'Hyväksymällä kaikki evästeet, suostut evästeiden tallentamiseen laitteellasi sivuston navigoinnin, analysoinnin, markkinoinnin  parantamiseksi.',
      learnMoreLinkText: 'Lisätietoa evästeistä',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Hallinnoi evästeitä',
      acceptAll: 'Hyväksy kaikki evästeet',
      manageTitle: 'Hallinnoi suostumuksiasi',
      necessaryCookiesTitle: 'Pakolliset evästeet',
      necessaryCookiesBody:
        'Nämä evästeet ovat pakollisia nettisivun toiminnallisuuden kannalta, eikä niitä voi ottaa pois käytöstä.',
      performanceCookiesTitle: 'Suorituskykyä mittaavat evästeet',
      performanceCookiesBody:
        'Nämä evästeet mahdollistavat käyntikertojen ja käyntikohteiden laskemisen, jotta voimme mitata ja parantaa sivustomme toiminnallisuuksia.',
      marketingCookiesTitle: 'Markkinointi evästeet',
      marketingCookiesBody:
        'Nämä evästeet mahdollistavat mainosten personalisoinnin ja mainosten tehokkuuden mittaamisen.',
      functionalCookiesTitle: 'Toiminnalliset evästeet',
      functionalCookiesBody:
        'Nämä evästeet parantavat nettisivun toiminnallisuuksia. Ilman näitä evästeitä tietyt toiminnallisuudet eivät ole käytettävissä, esimerkkeinä chat palvelut sekä tietyt käyttäjäasetukset.',
      confirmChoices: 'Hyväksy valinnat',
    },

    flash: {
      starting: 'Käynnistetään...',
      connection_error_hint: 'Verkkoyhteyttä ei voitu muodostaa.\nYritä ladata sivu uudelleen.',
      permission_hint: 'Kameran ja mikrofonin käyttö tulee sallia käyttääksesi palvelua.',
      searching_camera_hint: 'Etsitään kameraa...',
      camera_reserved_hint: 'Jokin toinen sovellus on varannut kamerasi.\nSulje sovellus ja lataa sivu uudestaan.',
      camera_reserved_hint_chrome_extra: '\n\nChromen käyttäjänä tarkista, että selaimen osoitepalkin alapuolelta olet antanut Recrightille luvan käyttää kameraa.',
      no_camera_hint: 'Web-kameraa ei löytynyt.',
      no_mic_hint: 'Mikrofonia ei löytynyt.',
      uploading_text: 'Videota tallennetaan ...',
      rtmpt_in_use: 'Tätä vaihetta ei tarvita, mikäli verkossasi\nsallitaan RTMP-videoyhteys. Kysy meiltä miten.',
      preview_text: 'Kamera on esikatselutilassa',
      close_text: 'Sulje kamera',
      remove_text: 'Poista otos',
      noflash_errortext_install: link => `Näyttää, että sinulla ei ole  Adobe Flash-lisäosaa. Tarvitset Flash-lisäosan videoiden nauhoittamiseen. Lataa ja asenna Flash täältä: ${link}`,
      noflash_errortext_enable: link => `Jos olet jo asentanut Flash-lisäosan, mutta näet silti tämän tekstin. Katso ohjeet täältä: ${link}`,
      noflash_errortext_differentbrowser: 'Vaihtoehtoisesti voit käyttää selainta, joka tukee HTML5-videoiden nauhoitusta. Suosittelemme Google Chrome tai Mozilla Firefox-selaimia.',
    },

    footer: {
      terms: 'Käyttöehdot',
      license: 'Käyttöoikeussopimus',
      privacyPolicy: 'Tietosuojaseloste',
      customSupport: link => `Ota yhteyttä ${link}`,
      accessibilityReport: 'Saavutettavuusseloste',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Millainen kokemus sinulle jäi videohaastattelusta?',
      howWouldYouRateJobAd: 'Millainen kokemus sinulle jäi hakuprosessista?',
      yourResponseIsAnonymous: 'Vastauksesi pysyy anonyyminä.',
      thankYouFeedback: 'Kiitos palautteestasi!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/fi/recright-kayttoehdot-hakija',
      privacyPolicyLink: 'https://new.recright.com/fi/tietosuojaseloste',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Saavutettavuusseloste.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Valitettavasti tiedostotyyppi ei ole sallittu.',
      isRequired: 'Tieto on pakollinen.',
      isEmail: value => `${value} on virheellinen sähköpostiosoite.`,
      isDate: value => `${value} on virheellinen päivämäärä.`,
      invalidUrl: 'Linkki on virheellinen',
      singleHireEndError: 'Yksittäinen rekrytointi on voimassa 60 päivän ajan.',
      isNotTooOldForLive: 'Päivämäärä on menneisyydessä.',
      isNotAfterEndDate: 'Valittu päivämäärä on ilmoituksen sulkeutumispäivän jälkeen.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Puhelinnumero on jo syötetty.',
      duplicateCompetency: 'Tämän niminen ominaisuus on jo olemassa',
      isNotDuplicateTemplateName: 'Tämän niminen pohja on jo olemassa.',
    },

    jobAdApplication: {
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      city: 'Kaupunki',
      applyForPosition: 'Hae työpaikkaa',
      back: 'Takaisin',
      continue: 'Jatka',
      submit: 'Lähetä',
      saveForLater: 'Jatka myöhemmin',
      namePlaceholder: 'Etunimi Sukunimi',
      emailPlaceholder: 'Sähköposti',
      phonePlaceholder: 'Puhelinnumero',
      cityPlaceholder: 'Nykyinen kotikaupunkisi',
      links: 'Lisää linkkejä, esim. LinkedIn -profiilisi',
      legendBasicInfo: 'Perustiedot',
      legendLinks: 'Linkit',
      legendAttachments: 'Liitetiedostot',
      legendAdditionalFields: 'Lisätietoja',
      coverLetter: 'Saatekirje',
      attachments: 'Liitteet',
      introduction: 'Kirjoita tähän vapaamuotoinen saatekirje',
      thankYou: 'Kiitos.',
      luck: 'Onnea!',
      close: 'Sulje',
      required: '* Tähdellä merkityt kentät ovat pakollisia.',
    },

    jobAdContainer: {
      endTime: date => (date ? `hakuaika päättyy ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Hae paikkaa',
    },

    jobAdQuickInterview: {
      back: 'Takaisin',
      submit: 'Lähetä',
      saveForLater: 'Jatka myöhemmin',
      title: 'Videoesittely',
      description: 'Vastaathan vielä allaolevaan kysymykseen lyhyellä videovastauksella. Tuo persoonasi esiin ja anna hakemuksellesi kasvot.',
      requiredNote: 'Huomaathan, että videoesittely on osa tätä hakuprosessia, ja rekrytoija näkee hakemuksesi vasta kun olet nauhoittanut vastauksen.',
      reminderNote: 'Voit nauhoittaa esittelyn heti, tai jatkaa myöhemmin tilaamalla sähköpostiisi muistutusviestin.',
    },

    jobAdRow: {
      responses: 'Hakemuksia',
      status: {
        open: 'Avoin',
        filled: 'Täytetty',
        cancelled: 'Peruutettu',
        done: 'Valmis',
        close: 'Sulje',
        draft: 'Suljettu (luonnos)',
        hidden: 'Piilotettu',
      },
    },

    interviewRow: {
      responses: 'Vastauksia',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Näytä LinkedIn profiili',
    },

    linkedInButton: {
      error: 'Virhe profiilia haettaessa. Yritä uudelleen.',
      buttonText: 'Hae LinkedIn-tiedot',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Voit käyttää Linkedin-profiilia hakemuksen esitäyttämiseen',
      linkedInOr: 'Tai',
      error: 'Virhe profiilia haettaessa. Yritä uudelleen.',
    },

    linkListInput: {
      addField: 'Lisää linkki',
      removeField: 'Poista linkki',
      invalidUrl: 'Linkki on virheellinen',
    },

    liveRoom: {
      greeting: name => `Hei, ${name}.`,
      notYetStarted: startTime =>
        `Haastattelu ei ole vielä alkanut. Haastattelu alkaa ${startTime}.`,
      interviewTitle: title => `Haastattelun nimi: ${title}`,
      interviewStartsIn: timeLeft => `Haastattelu alkaa: ${timeLeft}`,
      interviewHasEnded: 'Haastattelu on päättynyt.',
    },

    loadingButton: {
      loading: 'Ladataan...',
      saving: 'Tallennetaan...',
      sending: 'Lähetetään...',
    },

    modalApplicationForm: {
      applyForPosition: 'Hae työpaikkaa',
      continue: 'Jatka',
      name: 'Nimi',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      links: 'Linkit',
      legendLinks: 'Linkit',
      legendAttachments: 'Liitetiedostot',
      coverLetter: 'Saatekirje',
      attachments: 'Liitteet',
      introduction: 'Kirjoita tähän esittelysi',
      thankYou: 'Kiitos.',
      luck: 'Onnea!',
      close: 'Sulje',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Jaettava julkinen linkki',
      info: 'Tämä on työpaikan julkinen linkki jaettavaksi.\nKiinnostuneet voivat nähdä työpaikkailmoituksen \nja hakea työpaikkaa.\nSaat tiedon, kun hakemuksia alkaa saapua.\n\nTässä työpaikan linkki:',
    },

    modalVideoAdd: {
      chooseTitle: 'Lisää uusi video',
      title: 'Nauhoita uusi video',
      titlePlaceholder: 'Kirjoita ensin videon otsikko',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Lataa uusi video',
      info: 'Suurin sallittu tiedostokoko on 500mb. Suosittelemme pakkaamaan videot ennen palveluun lataamista, jotta lataaminen ja videoiden konvertointi valmistuisi nopeammin.',
    },

    modalCandidateInfo: [
      {
        headline: 'Nauhoita videovastaus ',
        content: 'niin monta kertaa kunnes olet tyytyväinen vastaukseesi. Videot tallentuvat sinulle heti nauhoituksen jälkeen ja voit palata hakemukseesi myöhemmin sähköpostiisi lähetetyn linkin kautta.',
        mobileContent: 'niin monta kertaa kunnes olet tyytyväinen vastaukseesi. Lisää video haastatteluun. Näet videon lataantuvan ja tallentuvan haastatteluun. Voit palata hakemukseesi myöhemmin sähköpostiisi lähetetyn linkin kautta. <br><br><strong> Jos nauhoitusruutusi on musta, ja käytät Applen mobiililaitetta ohjeet ongelman ratkaisuun löydät <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/fi/articles/11187-kamera-ei-toimi-ipad-iphone">täältä</a>.</strong>',
      },
      {
        headline: 'Tarkista videon nauhoittamisen jälkeen, ',
        content: 'että äänesi kuuluu selkeästi ja video toistuu normaalisti. Kun painat “lähetä vastaus” -painiketta, video lukitaan etkä enää pääse muokkaamaan vastaustasi.',
      },
      {
        headline: 'Kun olet nauhoittanut kaikki vastauksesi ',
        content: 'ja haastattelu on valmis, paina "lähetä vastaukset ja päätä haastattelu" -painiketta. Tämän jälkeen et voit enää palata haastatteluun. Jos haluat vielä jatkaa haastattelun tekoa myöhemmin paina “Jatka myöhemmin”-painiketta.',
      },
      {
        headline: 'Jos tarvitset apua ',
        content: mailto => `videohaastatteluun vastaamisessa, klikkaa oikean alakulman “apua”-painiketta tai lähetä sähköpostia osoitteeseen ${mailto}.`,
        customContent: link => `Ota yhteyttä ${link}`,
      },
    ],

    navigationBar: {
      back: 'Takaisin',
      dashboard: 'Päänäkymä',
      frontpage: 'Etusivulle',
    },

    personDetails: {
      stage: 'Vaihe',
      namePlaceholder: 'Hakija',
      contact: 'Yhteystiedot',
      links: 'Linkit',
      attachments: 'Liitteet',
      coverLetter: 'Kuvaus',
      referrer: 'Viitesivu',
      referrerInfo: 'Sivusto, jolta hakija saapui palveluun.',
      noStage: 'Ei vielä siirretty vaiheeseen',
      headerAdditionalInformation: 'Lisätietoja',
      lastSeen: time => `Viimeksi nähty ${time}.`,
      state: {
        invited: 'Kutsuttu',
        visited: 'Vieraillut',
        incomplete: 'Kesken',
        completed: 'Valmis',
      },
      notVisited: 'Ei ole vielä käynyt haastattelussa.',
      scheduledInterview: 'Tapaamisen tiedot',
      scheduledInterviewInvitationSent: 'Kutsuttu tapaamiseen',
      scheduledInterviewInvitationExpired: 'Kutsu on vanhentunut',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: 'Lähetä tapaamiskutsu uudelleen',
      otherPersons: count => `Hakija löytyy myös ${count} muusta positiosta`,
    },

    phoneInput: {
      placeholder: example => `Puhelinnumero muodossa ${example}`,
    },

    questionsAndResponses: {
      response: 'Vastaus',
      noResponse: 'Ei vastausta',
      resetQuestionResponse: 'Poista hakijan vastaus kysymykseen',
      resetQuestionResponseConfirm: questionTitle =>
        `Oletko varma, että haluat poistaa hakijan vastauksen kysymykseen "${questionTitle}"?`,
      resetQuestionResponseConfirm2: 'Jos poistat vastauksen, hakija voi vastata kysymykseen uudelleen.',
    },

    rating: {
      ownVote: 'Oma arvio',
      yourVotePlaceholder: 'Et ole lisännyt arviotasi.',
      totalVotes: count => `Yhteensä ${count} arviota`,
      noRatings: 'Ei vielä arvioita',
      mobileModalHeader: 'Lisää arviosi',
      yourRatingReset: 'Poista arviosi',
      averageRating: 'Keskiarvo',
      reset: 'poista',
    },

    share: {
      share: 'Jaa',
      copy: 'Kopioi linkki',
    },

    sort: {
      sort: 'Järjestä',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Valittu',
      change: 'Vaihda',
    },

    video: {
      videoNotFound: 'Videota käsitellään tai sitä ei löydy',
      retry: 'Yritä uudestaan',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Lataa tai nauhoita uusi video' : 'Valitse tiedosto'),
      videoPlaceholder: 'Nauhoita vastauksesi',
      uploadPlaceholderCandidate: 'Lataa valmis video',
      submit: 'Lähetä vastaus',
      notAnswered: 'Et ole vielä vastannut',
      remove: 'Poista otos',
      converting: 'Videota konvertoidaan. Odota hetki...',
      uploading: 'Videota lähetetään. Odota hetki...',
      error: {
        invalid: 'Valittu tiedosto on liian suuri. Valitse toinen tiedosto.',
        upload: 'Tiedoston lataaminen epäonnistui, yritä uudelleen.',
        transcode: 'Valittua videotiedostoa ei pystytty konvertoimaan, poista otos ja yritä uudelleen.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Näytä lisää',
      showLessButtonText: 'Näytä vähemmän',
      infoText1:
        'Pidä tämä välilehti aktiivisena etualalla nauhoituksen aikana. Ethän käytä muita sovelluksia nauhoituksen aikana.',
      infoText2:
        'Videotaustat toimivat parhaiten uusimmilla selaimilla ja tehokkailla laitteilla.',
      infoText3:
        'Varmista, että muut sovellukset eivät käytä mikrofonia tai kameraa. Se saattaa vaikuttaa videotaustan toimivuuteen.',
    },

    videoResponse: {
      videoPlaceholder: 'Nauhoita vastauksesi',
      uploadPlaceholder: 'Lataa valmis video',
      submit: 'Lähetä vastaus',
      notAnswered: 'Et ole vielä vastannut',
      startInterview: 'Aloita haastattelu',
    },

    webcam: {
      useVideoBgButtonText: 'Käytä videotaustaa',
      removeVideoBgButtonText: 'Poista videotausta',
      starting: 'Käynnistetään...',
      close: 'Sulje kamera',
      remove: 'Poista otos',
      record: 'Aloita nauhoitus',
      stop: 'Pysäytä',
      retake: 'Nauhoita uudelleen',
      submit: 'Lähetä vastaus',
      processing: 'Prosessoidaan...',
      converting: 'Videota konvertoidaan. Odota hetki...',
      uploading: 'Videota lähetetään. Odota hetki...',
      downloading: 'Videota ladataan. Odota hetki...',
      uploadInProgress: 'Videon siirto on vielä kesken, älä sulje selainta tai vaihda sivua.',
      uploaded: 'Video on siirretty.',
      error: {
        DevicesNotFoundError: 'Kameraa tai mikrofonia ei löytynyt. Tarkista, että kamera ja mikrofoni ovat käytettävissä.',
        NotFoundError: 'Kameraa tai mikrofonia ei löytynyt. Tarkista, että kamera ja mikrofoni ovat käytettävissä.',
        NotAllowedError: 'Ei oikeutta käyttää kameraa tai mikrofonia. Varmista, että olet antanut oikeuden käyttää kameraa ja mikrofonia.',
        PermissionDismissedError: 'Ohitit kameran tai mikrofonin oikeuskyselyn. Ole hyvä ja anna sivulle oikeudet käyttää kameraa ja mikrofonia.',
        PermissionDeniedError: 'Kameran tai mikrofonin käyttö estetty. Ole hyvä ja salli kameran ja mikrofonin käyttö.',
        NotReadableError: 'Kameran tai mikrofonin käyttö ei onnistunut. Mahdollisesti ongelma laitteistossa.',
        SecurityError: 'Kameran tai mikrofonin käyttö ei onnistunut mahdollisen tietoturva virheen vuoksi.',
        stream: 'Tapahtui virhe. Käynnistä selain uudestaan. Jos ongelma pysyy kokeile toisella selaimella.',
        download: 'Videon lataus epäonnistui. Yritä uudelleen?',
        upload: 'Videon tallennus epäonnistui. Yritä uudelleen?',
        emptyBlob: 'Selaimesi tai laiteesi muisti on täynnä, eikä se pysty käsittelemään videota. Uudelleenlataa sivu ja yritä nauhoitusta uudestaan. Jos tämä ei auta, käynnistä selain uudestaan. Jos ongelma pysyy kokeile toisella selaimella.',
        alternativeRecorder: 'Voit myös ladata videon painamalla tästä',
        reconnecting: 'Yhteyden muodostus epäonnistui. Yritetään muodostaa yheyttä uudelleen.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Hei, Sinut on kutsuttu videohaastatteluun ${title}! Sait tämän kutsun myös sähköpostiisi. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Tämä on haastattelun esikatselu. Nauhoitus on estetty, eikä lomakkeen tietoja tallenneta.',
    },
  },
}
